export enum PeriodicityOptions {
  ANUAL = 'Anual',
  MENSUAL = 'Mensual',
  SEMESTRAL = 'Semestral',
  Freemium = 'Freemium',
}
